import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { memo } from 'react';
import { useDropEventListContext, } from 'root/src/client/v2/_pages/drops/contexts/dropEventList.context';
import { maxDaresReachedMessage } from 'root/src/shared/constants/dropEvent';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import BlockFlippedIcon from '@mui/icons-material/Block';
export const DropUserInfoWidget = memo(() => {
    const { dropEvent } = useDropEventListContext();
    if (!dropEvent.dropUserInfo) {
        return <CheckOutDaresButton />;
    }
    const isMaxDaresReached = dropEvent.dropUserInfo.countOfAcceptedDares >= dropEvent.dropUserInfo.maxDares;
    const isAbleToParticipate = dropEvent.dropUserInfo.maxDares > 0;
    if (!isAbleToParticipate) {
        return <NotAbleToParticipate />;
    }
    if (isMaxDaresReached) {
        return <MaxDaresReached />;
    }
    return <CheckOutDaresButton />;
});
const NotAbleToParticipate = memo(() => {
    return (<div className="flex flex-col gap-2">
			<FontAwesomeIcon size="lg" icon={faLock}/>
			<span className="text-pink text-xs text-center">
				Need more Viewers to Participate
			</span>
		</div>);
});
const MaxDaresReached = memo(() => {
    return (<div className="flex flex-col gap-2">
			<FontAwesomeIcon size="lg" icon={faLock}/>
			<span className="text-pink text-xs text-center">
				{maxDaresReachedMessage}
			</span>
		</div>);
});
const CheckOutDaresButton = memo(() => {
    return (<div className="flex justify-center items-center">
			<ButtonNew className="font-bold">Check Out Dares</ButtonNew>
		</div>);
});
const FitWidgetWrapper = memo(({ children }) => (<div className="absolute right-3 bottom-3">
		{children}
	</div>));
export const FitWidget = memo(() => {
    const { dropEvent } = useDropEventListContext();
    const { isGoodMatch } = dropEvent.dropUserInfo || {};
    if (isGoodMatch === undefined) {
        return null;
    }
    if (isGoodMatch) {
        return (<FitWidgetWrapper>
				<BaseTooltip tooltip={(<BaseTooltipContent className="bg-link">
							This drop is a great fit for your content!
						</BaseTooltipContent>)}>
					<Badge className="gap-1 bg-link">
						<MilitaryTechIcon fontSize="small"/>
						<span className="text-xs uppercase font-bold">
							Best Fit
						</span>
					</Badge>
				</BaseTooltip>
			</FitWidgetWrapper>);
    }
    return (<FitWidgetWrapper>
			<BaseTooltip tooltip={(<BaseTooltipContent className="max-w-52 bg-pink">
						This drop is for creators with a strong focus on this genre, your content is not a close enough fit
					</BaseTooltipContent>)}>
				<Badge className="gap-1 bg-pink">
					<BlockFlippedIcon fontSize="small"/>
					<span className="text-xs uppercase font-bold">
						Low Fit
					</span>
				</Badge>
			</BaseTooltip>
		</FitWidgetWrapper>);
});
